import { StyleSheet } from 'react-native';
import { WARMUP_COLORS } from '../../../src/quiz/constants/warmup.constants';
import { FOOTBALLER_COLORS as C } from '../../../src/quiz/constants/footballerQuiz.constants';

export const TILE_SIZE = 54;
export const TILE_GAP = 6;

export const footballerQuizBoardStyles = StyleSheet.create({
  root: { flex: 1 },

  // Header
  header: { flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', paddingHorizontal: 2, paddingTop: 2, paddingBottom: 8 },
  pill: { flexDirection: 'row', alignItems: 'center', gap: 5, backgroundColor: C.surface, borderRadius: 9999, paddingVertical: 7, paddingHorizontal: 13 },
  pillFlame: { fontSize: 13 },
  pillStreak: { fontSize: 13, fontWeight: '700', color: C.yellow, fontVariant: ['tabular-nums'] },
  pillGuesses: { fontSize: 13, fontWeight: '700', color: C.purple, fontVariant: ['tabular-nums'] },
  pillDot: { width: 11, height: 11, borderRadius: 9999, borderWidth: 1.5, borderColor: C.purple },
  titleWrap: { alignItems: 'center' },
  title: { fontSize: 17, fontWeight: '800', color: WARMUP_COLORS.text, letterSpacing: -0.3 },
  subtitle: { fontSize: 9, fontWeight: '600', color: C.labelDim, letterSpacing: 1, marginTop: 1 },

  // Mystery card
  mysteryCard: {
    backgroundColor: C.surface, borderRadius: 16, paddingVertical: 14, paddingHorizontal: 16,
    borderWidth: 1, borderColor: C.cardBorder, flexDirection: 'row', alignItems: 'center', gap: 14, marginBottom: 10,
  },
  mysteryGlow: { width: 52, height: 52, borderRadius: 9999, backgroundColor: C.mysteryGlowBg, alignItems: 'center', justifyContent: 'center' },
  mysteryQ: { fontSize: 26, fontWeight: '900', color: C.purple, lineHeight: 30 },
  mysteryBody: { flex: 1, minWidth: 0 },
  mysteryTitle: { fontSize: 13, fontWeight: '700', color: WARMUP_COLORS.text },
  mysterySub: { fontSize: 11, color: C.labelDim, marginTop: 2 },
  dotsRow: { flexDirection: 'row', gap: 5, marginTop: 8, alignItems: 'center' },
  dot: { width: 7, height: 7, borderRadius: 9999, backgroundColor: C.tileEmpty },
  dotFilled: { backgroundColor: C.purple },
  dotWon: { backgroundColor: C.tileGreen },

  // Column labels (sticky)
  labelsRow: { flexDirection: 'row', gap: TILE_GAP, justifyContent: 'center', backgroundColor: C.bg, paddingTop: 4, paddingBottom: 8 },
  labelCell: { width: TILE_SIZE, alignItems: 'center' },
  labelText: { fontSize: 9, fontWeight: '700', color: C.labelFaint, letterSpacing: 0.8 },

  // Scroll area
  scroll: { flex: 1 },
  scrollContent: { paddingBottom: 10 },

  // Guessed rows
  rowWrap: { marginBottom: 10 },
  rowName: { textAlign: 'center', fontSize: 11, fontWeight: '700', color: C.hintText, letterSpacing: 0.5, marginBottom: 7 },
  tilesRow: { flexDirection: 'row', gap: TILE_GAP, justifyContent: 'center' },

  // Tile
  tile: {
    width: TILE_SIZE, height: TILE_SIZE, borderRadius: 9999, alignItems: 'center', justifyContent: 'center',
    backgroundColor: C.tileEmpty, borderWidth: 1, borderColor: C.tileEmptyBorder,
  },
  tileGreen: { backgroundColor: C.tileGreen, borderColor: C.tileGreen },
  tileAmber: { backgroundColor: C.yellow, borderColor: C.yellow },
  tileDiv: { fontSize: 8, fontWeight: '800', letterSpacing: 0.2, marginTop: 1 },
  tileClub: { fontSize: 8, fontWeight: '800', textAlign: 'center', lineHeight: 10, paddingHorizontal: 3 },
  tilePos: { fontSize: 13, fontWeight: '800' },
  tileAge: { fontSize: 16, fontWeight: '700', fontVariant: ['tabular-nums'], lineHeight: 18 },
  tileArrow: { fontSize: 10, lineHeight: 11, marginTop: 1 },

  // Search bar
  searchBar: { paddingTop: 8, paddingBottom: 4, borderTopWidth: 1, borderTopColor: C.divider, backgroundColor: C.bg },
  searchRow: { flexDirection: 'row', gap: 8, alignItems: 'center' },
  input: {
    flex: 1, height: 46, backgroundColor: C.inputBg, borderWidth: 1.5, borderColor: C.inputBorder,
    borderRadius: 10, paddingHorizontal: 14, fontSize: 14, fontWeight: '500', color: WARMUP_COLORS.text,
  },
  inputFocused: { borderColor: C.inputBorderFocus },
  submitBtn: { width: 46, height: 46, borderRadius: 10, backgroundColor: C.tileEmpty, alignItems: 'center', justifyContent: 'center' },
  submitBtnActive: { backgroundColor: C.purple },

  // Autocomplete
  dropdown: {
    position: 'absolute', bottom: 64, left: 0, right: 0, backgroundColor: C.dropdown, borderWidth: 1,
    borderColor: C.inputBorder, borderRadius: 12, overflow: 'hidden',
  },
  suggestion: { flexDirection: 'row', alignItems: 'center', gap: 10, paddingVertical: 11, paddingHorizontal: 14, borderBottomWidth: 1, borderBottomColor: 'rgba(255,255,255,0.05)' },
  suggestionAvatar: { width: 32, height: 32, borderRadius: 9999, backgroundColor: WARMUP_COLORS.purpleDeep, alignItems: 'center', justifyContent: 'center' },
  suggestionInitials: { fontSize: 11, fontWeight: '800', color: WARMUP_COLORS.text },
  suggestionBody: { flex: 1, minWidth: 0 },
  suggestionName: { fontSize: 13, fontWeight: '600', color: WARMUP_COLORS.text },
  suggestionMetaRow: { flexDirection: 'row', alignItems: 'center', gap: 5, marginTop: 2 },
  suggestionMeta: { fontSize: 11, color: C.labelDim, flexShrink: 1 },
  suggestionPos: { fontSize: 10, fontWeight: '700', color: C.labelDim, backgroundColor: C.chip, paddingVertical: 2, paddingHorizontal: 7, borderRadius: 5, overflow: 'hidden' },

  pressed: { opacity: 0.85 },
});
